/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Delete_Chat_TitleInputs */

const es_sidebar_delete_chat_title = /** @type {(inputs: Sidebar_Delete_Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eliminar chat?`)
};

const en_sidebar_delete_chat_title = /** @type {(inputs: Sidebar_Delete_Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete chat?`)
};

/**
* | output |
* | --- |
* | "Delete chat?" |
*
* @param {Sidebar_Delete_Chat_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const sidebar_delete_chat_title = /** @type {((inputs?: Sidebar_Delete_Chat_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Delete_Chat_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_sidebar_delete_chat_title(inputs)
	return en_sidebar_delete_chat_title(inputs)
});
export { sidebar_delete_chat_title as "sidebar.delete_chat_title" }